import React from "react";
import clsx from "clsx";
import { Row, Col } from "react-bootstrap";

import { floatWithComma2Normalizer } from "validators";

import { RowActions } from "./rowActions";

import styles from "../tables.module.scss";

// column: { type, value }
export const TableRow = ({
	rowNumber = 0,
	columns = [],
	onEditClick,
	onDeleteClick,
	actionsClassName,
	isEditable,
}) => {
	const getField = column => {
		switch (column.type) {
			case "date":
				return <span className="pl-1">{column.value}</span>;
			case "currency":
				const columnValue = `${
					column.value < 0 ? "- " : ""
				}${floatWithComma2Normalizer(
					Math.abs(column.value.replaceAll(",", "")),
					"$",
				)}`;
				return (
					<span title={columnValue} className="text-ellipsis">
						{columnValue}
					</span>
				);

			default:
				const err = { error: "Not supported" };
				throw err;
		}
	};

	return (
		<Row className={clsx(styles.row, "align-items-center", "m-0")}>
			{columns.map((column, i) => (
				<Col
					key={`col-${rowNumber}-${i}-${column.value}`}
					className={clsx(
						styles.columnValue,
						"d-flex",
						"align-items-center",
					)}
				>
					{getField(column)}
				</Col>
			))}
			{isEditable && (
				<RowActions
					onEditClick={onEditClick}
					onDeleteClick={onDeleteClick}
					className={actionsClassName}
				/>
			)}
		</Row>
	);
};
